export const getLoadedFilesMessageFormat = (files, isRtl) => {
  const message = {
    isRtl,
    type: 'attachments',
    attachments: [],
  }

  files.map(file => {
    const attachment = {
      type: file.type,
      title: file.name,
      payload: {
        url: file.url,
      },
    }

    message.attachments.push(attachment)
  })

  return message
}
